import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "ksmapContainer"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapassembly = _resolveComponent("mapassembly");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_mapassembly, {
    id: 1,
    ref: `map`,
    mapconfigdatas: $data.mapconfigdatas,
    onCloseHandle: $options.closeHandle,
    onTypeList: $options.typeListHandle,
    onDetail: $options.detailHandle
  }, null, 8, ["mapconfigdatas", "onCloseHandle", "onTypeList", "onDetail"]), _createElementVNode("ul", {
    class: "typeUl",
    style: _normalizeStyle({
      zIndex: $data.zindex
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      onClick: $event => $options.typeLiClick(item, index)
    }, [_createElementVNode("img", {
      src: $data.cTypeIndex === index ? $data.typeImg[index].urlOn : $data.typeImg[index].url,
      alt: ""
    }, null, 8, _hoisted_3)], 8, _hoisted_2);
  }), 256))], 4)]);
}